var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4.21875,
    fill: "#1756E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.1031C6 14.1497 6.03778 14.1875 6.08438 14.1875L16.3146 14.1875C16.3886 14.1875 16.4268 14.276 16.3759 14.3298L12.932 17.9725C12.9012 18.0051 12.9013 18.0561 12.9322 18.0886L13.7387 18.9356C13.772 18.9706 13.8279 18.9705 13.8611 18.9354L18.9452 13.558C18.9759 13.5254 18.9759 13.4746 18.9452 13.442L13.8613 8.06485C13.828 8.02964 13.772 8.02964 13.7387 8.06485L12.9383 8.91146C12.9075 8.94397 12.9075 8.99481 12.9382 9.02734L16.3762 12.6702C16.427 12.724 16.3889 12.8125 16.3149 12.8125L6.08438 12.8125C6.03778 12.8125 6 12.8503 6 12.8969L6 14.1031Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.421875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartOutline);
export default __webpack_public_path__ + "static/media/startOutline.739b11ede6272ab65034d1f0b8630d28.svg";
export { ForwardRef as ReactComponent };